/* ════════════════════════════════════════════════════════
   1. CURSOR
════════════════════════════════════════════════════════ */
const dot  = document.getElementById('cDot');
const ring = document.getElementById('cRing');
let mx=window.innerWidth/2, my=window.innerHeight/2;
let rx=mx, ry=my;

document.addEventListener('mousemove', e=>{ mx=e.clientX; my=e.clientY; });
document.addEventListener('mousedown', ()=>document.body.classList.add('cursor-down'));
document.addEventListener('mouseup',   ()=>document.body.classList.remove('cursor-down'));

document.querySelectorAll('a,button').forEach(el=>{
  el.addEventListener('mouseenter',()=>document.body.classList.add('cursor-hover'));
  el.addEventListener('mouseleave',()=>document.body.classList.remove('cursor-hover'));
});

(function cursorLoop(){
  rx += (mx-rx)*0.11; ry += (my-ry)*0.11;
  dot.style.left  = mx+'px'; dot.style.top  = my+'px';
  ring.style.left = rx+'px'; ring.style.top = ry+'px';
  requestAnimationFrame(cursorLoop);
})();


/* ── Collapse any DOM elements above #store that create the gap ── */
document.addEventListener('DOMContentLoaded', function() {
  const store = document.getElementById('store');
  if (!store) return;
  // Walk backwards through siblings before #store and collapse them
  // (except loader, glitch-overlay, flash, cursor which are fixed/hidden)
  const safeIds = new Set(['loader','glitch-overlay','flash','cursor']);
  const safeTags = new Set(['CART-DRAWER','CART-NOTIFICATION','SCRIPT','STYLE','LINK','META']);
  let el = store.previousElementSibling;
  while (el) {
    const isSafeId  = safeIds.has(el.id);
    const isSafeTag = safeTags.has(el.tagName);
    // Never hide cart-drawer or cart-notification — product form needs them
    const isCart = el.tagName === 'CART-DRAWER' || el.tagName === 'CART-NOTIFICATION'
                || el.id === 'CartDrawer' || (el.classList && el.classList.contains('cart-drawer'));
    if (!isSafeId && !isSafeTag && !isCart) {
      el.style.cssText += ';height:0!important;min-height:0!important;max-height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;display:none!important;';
    }
    el = el.previousElementSibling;
  }
  // Also zero out body top padding/margin
  document.body.style.paddingTop = '0';
  document.body.style.marginTop = '0';
});

/* ════════════════════════════════════════════════════════
   2. LOADER — Three.js orb → glitch static → logo flicker
════════════════════════════════════════════════════════ */
const loaderCanvas   = document.getElementById('loader-canvas');
const loaderPct      = document.getElementById('loaderPct');
const loaderBar      = document.getElementById('loaderBar');
const flash          = document.getElementById('flash');
const glitchOverlay  = document.getElementById('glitch-overlay');
const staticCanvas   = document.getElementById('static-canvas');
const glitchLogo     = document.querySelector('.glitch-logo');
const glitchLogoImg  = document.getElementById('glitchLogoImg');

/* ── Three.js orb ── */
let loaderAnimId;
const threeReady = typeof THREE !== 'undefined';

if (threeReady && loaderCanvas) {
  const LR = new THREE.WebGLRenderer({ canvas: loaderCanvas, alpha: true, antialias: true });
  const LS = Math.min(window.innerWidth, window.innerHeight, 520);
  LR.setSize(LS, LS);
  LR.setPixelRatio(window.devicePixelRatio || 1);
  const loaderScene  = new THREE.Scene();
  const loaderCamera = new THREE.PerspectiveCamera(50, 1, 0.1, 100);
  loaderCamera.position.z = 3.5;
  const orbGeo = new THREE.IcosahedronGeometry(1, 7);
  const orbMat = new THREE.ShaderMaterial({
    uniforms: { time:{value:0}, intensity:{value:0},
      color1:{value:new THREE.Color(0xF5E132)}, color2:{value:new THREE.Color(0xFFFFAA)} },
    vertexShader:`
      uniform float time,intensity; varying vec3 vNormal; varying float vNoise;
      float hash(vec3 p){p=fract(p*vec3(443.897,441.423,437.195));p+=dot(p,p.yzx+19.19);return fract((p.x+p.y)*p.z);}
      float noise(vec3 p){vec3 i=floor(p);vec3 f=fract(p);f=f*f*(3.0-2.0*f);
        return mix(mix(mix(hash(i),hash(i+vec3(1,0,0)),f.x),mix(hash(i+vec3(0,1,0)),hash(i+vec3(1,1,0)),f.x),f.y),
                   mix(mix(hash(i+vec3(0,0,1)),hash(i+vec3(1,0,1)),f.x),mix(hash(i+vec3(0,1,1)),hash(i+vec3(1,1,1)),f.x),f.y),f.z);}
      void main(){vNormal=normalize(normalMatrix*normal);
        float n=noise(position*2.2+time*0.6),n2=noise(position*4.5-time*0.4);
        float d=(n*.7+n2*.3)*intensity;vNoise=d;
        gl_Position=projectionMatrix*modelViewMatrix*vec4(position+normal*d*.28,1.);}`,
    fragmentShader:`
      uniform vec3 color1,color2; varying vec3 vNormal; varying float vNoise;
      void main(){float f=pow(1.-max(dot(vNormal,vec3(0.,0.,1.)),0.),2.5);
        gl_FragColor=vec4(mix(color1,color2,clamp(vNoise*2.5+f,0.,1.)),.88+f*.12);}`,
    transparent:true, side:THREE.DoubleSide
  });
  const orb = new THREE.Mesh(orbGeo, orbMat);
  loaderScene.add(orb);
  loaderScene.add(new THREE.AmbientLight(0xffffff, 0.3));
  const pt = new THREE.PointLight(0xF5E132, 2.5, 8);
  pt.position.set(2,2,2); loaderScene.add(pt);
  let t = 0;
  (function loaderLoop(){
    loaderAnimId = requestAnimationFrame(loaderLoop);
    t += 0.016;
    orbMat.uniforms.time.value = t;
    orbMat.uniforms.intensity.value = Math.min(t * 0.4, 1.0);
    orb.rotation.y += 0.008;
    LR.render(loaderScene, loaderCamera);
  })();
}

/* ── Static noise on canvas ── */
function drawStatic(canvas, intensity) {
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  canvas.width  = window.innerWidth;
  canvas.height = window.innerHeight;
  const img = ctx.createImageData(canvas.width, canvas.height);
  const d = img.data;
  for (let i = 0; i < d.length; i += 4) {
    const v = Math.random() < intensity ? (Math.random() * 255) : 0;
    d[i]=d[i+1]=d[i+2]=v; d[i+3]=v > 0 ? 220 : 0;
  }
  ctx.putImageData(img, 0, 0);
}

let staticAnimId;
function startStatic(intensity) {
  function loop(){ staticAnimId = requestAnimationFrame(loop); drawStatic(staticCanvas, intensity); }
  loop();
}
function stopStatic() { if (staticAnimId) cancelAnimationFrame(staticAnimId); }

/* ── Progress counter ── */
let pct = 0;
const loaderInterval = setInterval(() => {
  const step = pct < 70 ? Math.random()*3+1.5
             : pct < 92 ? Math.random()*1.5+0.5
             : Math.random()*0.6;
  pct = Math.min(pct + step, 100);
  if (loaderPct) loaderPct.childNodes[0].textContent = Math.floor(pct);
  if (loaderBar)  loaderBar.style.width = pct + '%';

  if (pct >= 100) {
    clearInterval(loaderInterval);

    // 1. Fade loader out while glitch overlay fades IN over the site
    setTimeout(() => {
      const loader = document.getElementById('loader');
      if (loader) {
        loader.classList.add('out');
        setTimeout(() => { loader.style.display = 'none'; }, 500);
      }
      if (loaderAnimId) cancelAnimationFrame(loaderAnimId);

      // Show site briefly underneath
      const store = document.getElementById('store');
      if (store) { store.style.opacity='1'; store.style.visibility='visible'; store.classList.add('visible'); }
      initHeroScene();
    }, 150);

    // 2. Slam glitch overlay on top — pure static, no logo yet
    setTimeout(() => {
      if (glitchOverlay) glitchOverlay.classList.add('active');
      startStatic(0.55); // heavy static
    }, 350);

    // 3. Logo bursts through static (glitching)
    setTimeout(() => {
      if (glitchLogo) {
        glitchLogo.style.opacity = '1';
        glitchLogo.classList.add('glitching');
      }
      startStatic(0.4); // still heavy but slightly less
    }, 750);

    // 4. Static fades, logo steadies into clean glow
    setTimeout(() => {
      stopStatic();
      startStatic(0.15); // light static
      if (glitchLogo) glitchLogo.classList.remove('glitching');
      // Neon flicker on logo
      const flickers = [0, 60, 110, 190, 260, 350, 420, 500];
      flickers.forEach((t, i) => {
        setTimeout(() => {
          if (glitchLogoImg) glitchLogoImg.style.opacity = (i % 2 === 0) ? '1' : '0.1';
        }, t);
      });
    }, 1250);

    // 5. Clear everything — site fully revealed
    setTimeout(() => {
      stopStatic();
      if (flash) { flash.style.opacity='1'; setTimeout(()=>{flash.style.opacity='0';},70); }
      if (glitchLogoImg) {
        glitchLogoImg.style.opacity = '1';
        glitchLogoImg.style.filter = 'brightness(0) saturate(100%) invert(1) sepia(1) saturate(2) hue-rotate(10deg) drop-shadow(0 0 24px rgba(245,225,50,1)) drop-shadow(0 0 60px rgba(245,225,50,0.5))';
      }
      setTimeout(() => {
        if (glitchOverlay) {
          glitchOverlay.style.transition = 'opacity 0.4s';
          glitchOverlay.style.opacity = '0';
          setTimeout(() => { glitchOverlay.classList.remove('active'); glitchOverlay.style.opacity=''; glitchOverlay.style.transition=''; }, 400);
        }
      }, 300);
    }, 1900);
  }
}, 38);

/* ════════════════════════════════════════════════════════
   3. HERO THREE.JS SCENE — floating wireframe objects
════════════════════════════════════════════════════════ */
function initHeroScene(){
  const heroCanvas = document.getElementById('hero-canvas');
  const HR = new THREE.WebGLRenderer({canvas:heroCanvas, alpha:true, antialias:true});
  HR.setPixelRatio(Math.min(window.devicePixelRatio||1, 2));
  HR.setSize(window.innerWidth, window.innerHeight);

  const HS = new THREE.Scene();
  const HC = new THREE.PerspectiveCamera(60, window.innerWidth/window.innerHeight, 0.1, 200);
  HC.position.z = 14;

  // ── LEMON BOY FACTORY ──────────────────────────────────────
  // Builds a Lemon Boy character from Three.js primitives.
  // armPose: 'normal' | 'up' | 'out' | 'wave'
  // leafTilt: radians added to leaf rotation
  // eyeStyle: 'normal' | 'wide' | 'sleepy'
  // ─────────────────────────────────────────────────────────
  function createLemonBoy({ scale=1, armPose='normal', leafTilt=0, eyeStyle='normal' } = {}) {
    const root = new THREE.Group();

    // Crisp edges wireframe + ghost fill helper
    function part(geo, wireOp=0.45, fillOp=0.04) {
      const g = new THREE.Group();
      g.add(new THREE.Mesh(
        geo.clone(),
        new THREE.MeshBasicMaterial({ color:0xF5E132, transparent:true, opacity:fillOp, depthWrite:false })
      ));
      g.add(new THREE.LineSegments(
        new THREE.EdgesGeometry(geo),
        new THREE.LineBasicMaterial({ color:0xF5E132, transparent:true, opacity:wireOp })
      ));
      return g;
    }

    // ── BODY (scaled ellipsoid) ──────────────────────────────
    const bodyGrp = part(new THREE.SphereGeometry(1, 16, 14));
    bodyGrp.scale.set(0.88, 1.12, 0.78);
    root.add(bodyGrp);

    // ── STEM ────────────────────────────────────────────────
    const stemGrp = part(new THREE.CylinderGeometry(0.045, 0.055, 0.32, 6), 0.65);
    stemGrp.position.set(0, 1.22, 0);
    root.add(stemGrp);

    // ── LEAF 1 (tall, angled left) ───────────────────────────
    // Build leaf as a flattened cone with 5 sides — diamond-ish silhouette
    const lf1Grp = part(new THREE.ConeGeometry(0.3, 0.85, 5), 0.52);
    lf1Grp.position.set(-0.1, 1.68, 0);
    lf1Grp.rotation.set(0, 0.4, 0.28 + leafTilt);
    root.add(lf1Grp);

    // ── LEAF 2 (shorter, angled right) ──────────────────────
    const lf2Grp = part(new THREE.ConeGeometry(0.24, 0.68, 5), 0.48);
    lf2Grp.position.set(0.22, 1.54, 0);
    lf2Grp.rotation.set(0, -0.5, -0.62 + leafTilt);
    root.add(lf2Grp);

    // ── EYES ────────────────────────────────────────────────
    // Normal: oval; Wide: bigger circles; Sleepy: flat ovals
    const eyeW = eyeStyle === 'wide' ? 0.12 : eyeStyle === 'sleepy' ? 0.11 : 0.1;
    const eyeH = eyeStyle === 'sleepy' ? 0.06 : 0.13;
    const eyeGeo = new THREE.SphereGeometry(1, 8, 6);
    for (const x of [-0.26, 0.26]) {
      const eye = part(eyeGeo.clone(), 0.9, 0.12);
      eye.scale.set(eyeW, eyeH, 0.06);
      eye.position.set(x, 0.22, 0.7);
      root.add(eye);
    }

    // ── CHEEK BLUSH (flat ellipses) ──────────────────────────
    const blushGeo = new THREE.CircleGeometry(0.13, 10);
    for (const x of [-0.46, 0.46]) {
      const blush = part(blushGeo.clone(), 0.25, 0.08);
      blush.position.set(x, 0.04, 0.71);
      blush.scale.set(0.9, 0.65, 1);
      root.add(blush);
    }

    // ── SMILE (half torus, rotated so opening faces up = happy) ─
    const smileGrp = part(new THREE.TorusGeometry(0.21, 0.038, 5, 12, Math.PI), 0.75, 0);
    smileGrp.position.set(0, -0.1, 0.72);
    smileGrp.rotation.set(0, 0, Math.PI);
    root.add(smileGrp);

    // ── ARMS ────────────────────────────────────────────────
    const armGeo = new THREE.CylinderGeometry(0.065, 0.055, 0.52, 6);
    const lArm = part(armGeo.clone());
    const rArm = part(armGeo.clone());

    if (armPose === 'up') {
      // V for victory — arms raised outward and upward
      lArm.position.set(-0.82, 0.28, 0); lArm.rotation.z =  1.9;
      rArm.position.set( 0.82, 0.28, 0); rArm.rotation.z = -1.9;
    } else if (armPose === 'out') {
      // T-pose arms straight out horizontal
      lArm.position.set(-1.0, -0.02, 0); lArm.rotation.z =  Math.PI * 0.5;
      rArm.position.set( 1.0, -0.02, 0); rArm.rotation.z = -Math.PI * 0.5;
    } else if (armPose === 'wave') {
      // Left arm straight out, right arm raised at angle
      lArm.position.set(-0.95, -0.18, 0); lArm.rotation.z =  0.38;
      rArm.position.set( 0.82,  0.22, 0); rArm.rotation.z = -1.75;
    } else {
      // Normal — natural hanging arms
      lArm.position.set(-0.92, -0.22, 0); lArm.rotation.z =  0.38;
      rArm.position.set( 0.92, -0.22, 0); rArm.rotation.z = -0.38;
    }
    root.add(lArm); root.add(rArm);

    // ── HANDS (small spheres at arm tips) ───────────────────
    const handGeo = new THREE.SphereGeometry(0.095, 6, 5);
    const lHand = part(handGeo.clone(), 0.55);
    const rHand = part(handGeo.clone(), 0.55);
    if (armPose === 'up') {
      lHand.position.set(-0.52,  0.58, 0);
      rHand.position.set( 0.52,  0.58, 0);
    } else if (armPose === 'out') {
      lHand.position.set(-1.38, -0.02, 0);
      rHand.position.set( 1.38, -0.02, 0);
    } else if (armPose === 'wave') {
      lHand.position.set(-1.22, -0.44, 0);
      rHand.position.set( 0.50,  0.56, 0);
    } else {
      lHand.position.set(-1.20, -0.46, 0);
      rHand.position.set( 1.20, -0.46, 0);
    }
    root.add(lHand); root.add(rHand);

    // ── LEGS (short cylinders) ───────────────────────────────
    const legGeo = new THREE.CylinderGeometry(0.09, 0.08, 0.44, 6);
    const lLeg = part(legGeo.clone());
    lLeg.position.set(-0.3, -1.32, 0);
    root.add(lLeg);
    const rLeg = part(legGeo.clone());
    rLeg.position.set( 0.3, -1.32, 0);
    root.add(rLeg);

    // ── SHOES (boxes with slight toe bump) ──────────────────
    const shoeGeo = new THREE.BoxGeometry(0.28, 0.13, 0.34);
    const lShoe = part(shoeGeo.clone(), 0.55);
    lShoe.position.set(-0.3, -1.62, 0.06);
    root.add(lShoe);
    const rShoe = part(shoeGeo.clone(), 0.55);
    rShoe.position.set( 0.3, -1.62, 0.06);
    root.add(rShoe);

    root.scale.setScalar(scale);
    return root;
  }

  // ── SPAWN 6 LEMON BOY VARIATIONS ───────────────────────────
  // Each has a different pose, size, position, and spin speed
  const lemonBoys = [];

  function spawnLB(config, pos, rotSpeed) {
    const lb = createLemonBoy(config);
    lb.position.set(...pos);
    HS.add(lb);
    lemonBoys.push({ group: lb, rotSpeed, baseY: pos[1], phase: Math.random() * Math.PI * 2 });
  }

  // 1. Classic Boy — left side, standard pose
  spawnLB({ scale:1.2, armPose:'normal', leafTilt: 0 },
          [-8, 1.5, -5], { x:0.003, y:0.007, z:0.002 });

  // 2. Big Champ — back right, arms raised in V, bigger
  spawnLB({ scale:1.9, armPose:'up', leafTilt: 0.1, eyeStyle:'wide' },
          [8, -1.5, -10], { x:0.002, y:0.004, z:0.003 });

  // 3. Little Waver — upper center, waving arm, small
  spawnLB({ scale:0.72, armPose:'wave', leafTilt: 0.22 },
          [2, 4, -3], { x:0.005, y:0.009, z:0.002 });

  // 4. Sleepy Lad — bottom left, slightly rotated, sleepy eyes
  spawnLB({ scale:0.95, armPose:'normal', leafTilt:-0.18, eyeStyle:'sleepy' },
          [-4.5, -3.5, -5], { x:0.004, y:0.005, z:0.006 });

  // 5. Hype Boy — right mid, arms out T-pose
  spawnLB({ scale:1.05, armPose:'out', leafTilt: 0.08 },
          [5.5, 3, -7], { x:0.006, y:0.004, z:0.003 });

  // 6. Tiny Dancer — bottom right, fast spin
  spawnLB({ scale:0.58, armPose:'wave', leafTilt:-0.1, eyeStyle:'wide' },
          [0.5, -4.5, -2], { x:0.003, y:0.013, z:0.005 });

  // Big ghost lemon orb silhouette in the very background
  const bgOrb = new THREE.LineSegments(
    new THREE.EdgesGeometry(new THREE.IcosahedronGeometry(6, 2)),
    new THREE.LineBasicMaterial({ color:0xF5E132, transparent:true, opacity:0.03 })
  );
  bgOrb.position.set(6, 0, -22);
  HS.add(bgOrb);

  // Point light that drifts
  const heroLight = new THREE.PointLight(0xF5E132, 1.5, 40);
  heroLight.position.set(0,0,10);
  HS.add(heroLight);

  // Mouse parallax
  let targetX=0, targetY=0, currentX=0, currentY=0;
  window.addEventListener('mousemove', e=>{
    targetX = ((e.clientX/window.innerWidth) - 0.5) * 3.5;
    targetY = -((e.clientY/window.innerHeight) - 0.5) * 2.0;
  });

  let heroT = 0;
  function heroLoop(){
    requestAnimationFrame(heroLoop);
    heroT += 0.012;

    // Smooth camera parallax
    currentX += (targetX - currentX) * 0.04;
    currentY += (targetY - currentY) * 0.04;
    HC.position.x = currentX * 0.4;
    HC.position.y = currentY * 0.4;
    HC.lookAt(0,0,0);

    // Float and spin each Lemon Boy
    lemonBoys.forEach(({ group, rotSpeed, baseY, phase }) => {
      group.rotation.x += rotSpeed.x;
      group.rotation.y += rotSpeed.y;
      group.rotation.z += rotSpeed.z * 0.4; // gentler z roll so character stays readable
      group.position.y = baseY + Math.sin(heroT * 0.45 + phase) * 0.55;
    });

    bgOrb.rotation.y += 0.0008;
    bgOrb.rotation.x += 0.0004;

    heroLight.position.x = Math.sin(heroT*0.3)*8;
    heroLight.position.y = Math.cos(heroT*0.2)*4;

    HR.render(HS, HC);
  }
  heroLoop();

  // Resize
  window.addEventListener('resize',()=>{
    HC.aspect = window.innerWidth/window.innerHeight;
    HC.updateProjectionMatrix();
    HR.setSize(window.innerWidth, window.innerHeight);
  });
}

// Hero is now started directly after loader completes (see loader section above)

/* ════════════════════════════════════════════════════════
   4. CARD 3D TILT
════════════════════════════════════════════════════════ */
document.querySelectorAll('.pc').forEach(card=>{
  const inner = card.querySelector('.pc-inner');
  card.addEventListener('mousemove', e=>{
    const rect  = card.getBoundingClientRect();
    const x = ((e.clientX - rect.left)/rect.width  - 0.5)*22;
    const y = -((e.clientY - rect.top )/rect.height - 0.5)*16;
    inner.style.transform = `rotateY(${x}deg) rotateX(${y}deg) translateZ(12px)`;
    const glow = card.querySelector('.pc-glow');
    const gx = ((e.clientX - rect.left)/rect.width)*100;
    const gy = ((e.clientY - rect.top)/rect.height)*100;
    if(glow) glow.style.background = `radial-gradient(circle at ${gx}% ${gy}%,rgba(245,225,50,0.25),transparent 65%)`;
  });
  card.addEventListener('mouseleave', ()=>{
    inner.style.transform = '';
  });
});

/* Perk spotlight */
document.querySelectorAll('.perk').forEach(p=>{
  p.addEventListener('mousemove',e=>{
    const r=p.getBoundingClientRect();
    p.style.setProperty('--mx',((e.clientX-r.left)/r.width*100)+'%');
    p.style.setProperty('--my',((e.clientY-r.top)/r.height*100)+'%');
  });
});

/* ════════════════════════════════════════════════════════
   5. CART — Shopify Ajax Cart API (works on all pages)
════════════════════════════════════════════════════════ */

/* ── Helpers ── */
function moneyFmt(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* ── Our LemonBoy cart drawer (homepage sidebar) ── */
const cartOverlay = document.getElementById('cart-overlay');
const cartDrawer  = document.getElementById('cart-drawer');
const cartItemsEl = document.getElementById('cartItems');
const cartFtrEl   = document.getElementById('cartFtr');
const cartCountEl = document.getElementById('cartCount');
const cartTotalEl = document.getElementById('cartTotal');

function openCart()  {
  if (cartOverlay) cartOverlay.classList.add('open');
  if (cartDrawer)  cartDrawer.classList.add('open');
}
function closeCart() {
  if (cartOverlay) cartOverlay.classList.remove('open');
  if (cartDrawer)  cartDrawer.classList.remove('open');
}

if (document.getElementById('cartToggle'))
  document.getElementById('cartToggle').addEventListener('click', openCart);
if (document.getElementById('cartClose'))
  document.getElementById('cartClose').addEventListener('click', closeCart);
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

function renderCart(cart) {
  if (!cartItemsEl) return;
  if (!cart || cart.item_count === 0) {
    cartItemsEl.innerHTML = '<div class="cart-empty"><span class="big-emoji">🍋</span><p>Your cart is empty</p></div>';
    if (cartFtrEl) cartFtrEl.style.display = 'none';
  } else {
    if (cartFtrEl) cartFtrEl.style.display = 'block';
    cartItemsEl.innerHTML = cart.items.map(item => {
      const img = item.featured_image && item.featured_image.url
        ? `<img src="${item.featured_image.url}" alt="${item.product_title}"/>`
        : '';
      const variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<div class="cart-item-variant">${item.variant_title}</div>` : '';
      return `<div class="cart-item">
        <div class="cart-item-img">${img}</div>
        <div style="flex:1">
          <div class="cart-item-name">${item.product_title}</div>
          ${variant}
          <div class="cart-item-price">${moneyFmt(item.price)}</div>
          <div class="cart-item-qty">
            <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity-1}">−</button>
            <span>${item.quantity}</span>
            <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity+1}">+</button>
          </div>
        </div>
        <button class="cart-item-remove" data-key="${item.key}">✕</button>
      </div>`;
    }).join('');
    cartItemsEl.querySelectorAll('.qty-btn').forEach(b =>
      b.addEventListener('click', () => cartChange(b.dataset.key, parseInt(b.dataset.qty))));
    cartItemsEl.querySelectorAll('.cart-item-remove').forEach(b =>
      b.addEventListener('click', () => cartChange(b.dataset.key, 0)));
  }
  if (cartTotalEl) cartTotalEl.textContent = moneyFmt(cart.total_price || 0);
  if (cartCountEl) cartCountEl.textContent = cart.item_count || 0;
  // Also update ANY native Shopify cart count bubble
  document.querySelectorAll('.cart-count-bubble span, #cart-icon-bubble .visually-hidden').forEach(el => {
    if (!isNaN(parseInt(el.textContent)) || el.textContent.trim() === '') el.textContent = cart.item_count || 0;
  });
}

function fetchCart() {
  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(r => r.json())
    .then(cart => { renderCart(cart); return cart; })
    .catch(() => {});
}

function cartAdd(variantId, qty) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: qty || 1 }] })
  })
  .then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); })
  .then(() => fetchCart());
}

function cartChange(key, qty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(cart => renderCart(cart));
}

/* ── Homepage Quick Add buttons ── */
document.querySelectorAll('.pc-quick').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation();
    const vid = btn.dataset.pid;
    if (!vid || btn.disabled) return;
    const orig = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = 'Adding...';
    cartAdd(vid, 1)
      .then(() => {
        btn.textContent = 'Added! 🍋';
        btn.classList.add('added');
        openCart();
        setTimeout(() => { btn.textContent = orig; btn.classList.remove('added'); btn.disabled = false; }, 1600);
      })
      .catch(() => { btn.textContent = 'Error'; btn.disabled = false; setTimeout(() => { btn.textContent = orig; }, 2000); });
  });
});

/* ── Intercept ALL Shopify product forms on any page ── */
document.addEventListener('submit', function(e) {
  const form = e.target;
  // Only intercept product add-to-cart forms
  if (!form.matches('form[action="/cart/add"], form[action*="cart/add"]')) return;
  e.preventDefault();
  e.stopImmediatePropagation();

  const submitBtn = form.querySelector('[type="submit"], button[name="add"]');
  const origText  = submitBtn ? submitBtn.textContent.trim() : '';
  if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }

  const formData = new FormData(form);
  const variantId = formData.get('id');
  const qty = parseInt(formData.get('quantity') || '1');

  if (!variantId) {
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
    return;
  }

  cartAdd(variantId, qty)
    .then(() => {
      if (submitBtn) { submitBtn.textContent = 'Added! ✓'; }
      // Open our cart drawer if on homepage, otherwise show a quick toast
      if (document.getElementById('cartToggle')) {
        openCart();
      } else {
        showCartToast();
      }
      setTimeout(() => {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
      }, 1800);
    })
    .catch(() => {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
    });
}, true); // capture phase so we beat Shopify's own listener

/* ── Cart toast for product pages (no drawer there) ── */
function showCartToast() {
  let toast = document.getElementById('lbl-cart-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'lbl-cart-toast';
    toast.innerHTML = `<span>🍋 Added to cart!</span><a href="/cart">View Cart →</a>`;
    document.body.appendChild(toast);
  }
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), 3000);
}

fetchCart();

/* ════════════════════════════════════════════════════════
   6. WAVE FILTER ANIMATION (surreal text)
════════════════════════════════════════════════════════ */
const wt = document.getElementById('wt');
let wavT = 0;
function animWave(){
  requestAnimationFrame(animWave);
  wavT += 0.008;
  if(wt){
    wt.setAttribute('baseFrequency', `${0.013+Math.sin(wavT)*0.006} ${0.055+Math.cos(wavT*0.7)*0.025}`);
    wt.setAttribute('seed', Math.floor(Math.abs(Math.sin(wavT*0.2))*100));
  }
}
animWave();


/* ── Update squeeze hint for touch ── */
(function(){
  const hint = document.getElementById('squeezeHint');
  if (hint && ('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
    hint.textContent = '👆 TAP & DRAG TO SQUEEZE';
  }
})();
/* ════════════════════════════════════════════════════════
   8. SQUEEZE LEMON — Mario 64 Soft-Body Physics
   Spring-mass Verlet simulation with skinned face features.
   Grab any surface point and pull/squish like SM64's title.
════════════════════════════════════════════════════════ */
(function initSqueeze(){
  const canvas = document.getElementById('squeezeCanvas');
  if(!canvas) return;

  // Resize canvas for mobile
  function resizeSqueezeCanvas() {
    const maxSize = Math.min(window.innerWidth - 40, 540);
    const size = window.innerWidth < 600 ? Math.min(window.innerWidth - 48, 300) : maxSize;
    canvas.style.width  = size+'px';
    canvas.style.height = size+'px';
  }
  resizeSqueezeCanvas();
  window.addEventListener('resize', resizeSqueezeCanvas);
  const ctx = canvas.getContext('2d');

  /* ── Canvas setup (hi-DPI) ─────────────────────────── */
  const DPR = Math.min(window.devicePixelRatio||1, 2);
  const W = 540, H = 540;
  canvas.width  = W * DPR;
  canvas.height = H * DPR;
  canvas.style.width  = W+'px';
  canvas.style.height = H+'px';
  ctx.scale(DPR, DPR);

  const CX = W/2, CY = H/2 + 12;

  /* ── Points ─────────────────────────────────────────── */
  // Each point: x,y (current), ox,oy (prev Verlet), rx,ry (rest/original)
  const pts = [];
  const mkPt = (x,y) => ({ x, y, ox:x, oy:y, rx:x, ry:y });

  // Outer perimeter: 40 points, lemon ellipse
  const N = 40;
  const BRX = 112, BRY = 145;
  function lemonAngle(i){
    // Start at top (-PI/2), go clockwise
    return (i/N)*Math.PI*2 - Math.PI/2;
  }
  for(let i=0;i<N;i++){
    const t = lemonAngle(i);
    // Slight lemon shape: pointier at top, rounder at bottom
    const rx = BRX * (1 - 0.03*Math.cos(t*2));
    pts.push(mkPt(CX + rx*Math.cos(t), CY + BRY*Math.sin(t)));
  }

  // Inner ring: 20 points at ~52% radius
  const N_IN = 20, IN_START = pts.length;
  const IR = 0.52;
  for(let i=0;i<N_IN;i++){
    const t = (i/N_IN)*Math.PI*2 - Math.PI/2;
    pts.push(mkPt(CX + BRX*IR*Math.cos(t), CY + BRY*IR*Math.sin(t)));
  }

  // Center
  const C_IDX = pts.length;
  pts.push(mkPt(CX, CY));

  const TOTAL = pts.length;

  /* ── Springs ────────────────────────────────────────── */
  const springs = [];
  function addSp(a, b, k){
    const dx = pts[b].x-pts[a].x, dy = pts[b].y-pts[a].y;
    springs.push({ a, b, rest:Math.sqrt(dx*dx+dy*dy), k });
  }

  // Outer ring — structural + bending + long-range
  for(let i=0;i<N;i++){
    addSp(i, (i+1)%N,  0.62); // adjacent (structural)
    addSp(i, (i+2)%N,  0.38); // skip-1   (bend resistance)
    addSp(i, (i+4)%N,  0.22); // skip-3   (shape preservation)
    addSp(i, (i+9)%N,  0.07); // skip-8   (long-range, keeps volume)
  }

  // Outer → inner
  for(let i=0;i<N;i++){
    const j  = IN_START + (Math.round(i*N_IN/N))     % N_IN;
    const j2 = IN_START + (Math.round(i*N_IN/N) + 1) % N_IN;
    addSp(i, j,  0.38);
    addSp(i, j2, 0.22);
  }

  // Inner ring
  for(let i=0;i<N_IN;i++){
    addSp(IN_START+i, IN_START+(i+1)%N_IN, 0.52);
    addSp(IN_START+i, IN_START+(i+2)%N_IN, 0.32);
    addSp(IN_START+i, IN_START+(i+4)%N_IN, 0.14);
  }

  // Inner → center
  for(let i=0;i<N_IN;i++){
    addSp(IN_START+i, C_IDX, 0.42);
  }

  // Outer → center (pressure springs, keep body volume)
  for(let i=0;i<N;i+=2){
    addSp(i, C_IDX, 0.07);
  }

  /* ── Skinning ────────────────────────────────────────── */
  // Weighted average of k nearest points (computed once at rest).
  // Each frame, use same weights on deformed positions → automatic deformation.
  function createSkin(ox, oy, k=7){
    const items = pts
      .map((p,i)=>({ i, d:Math.hypot(p.rx-ox, p.ry-oy) }))
      .sort((a,b)=>a.d-b.d).slice(0,k);
    const sum = items.reduce((s,it)=>s+1/(it.d+0.8),0);
    const weights = items.map(it=>({ i:it.i, w:(1/(it.d+0.8))/sum }));
    return {
      get x(){ return weights.reduce((s,w)=>s+pts[w.i].x*w.w, 0); },
      get y(){ return weights.reduce((s,w)=>s+pts[w.i].y*w.w, 0); },
      ox, oy
    };
  }

  // Face + body feature anchors (in original/rest space)
  const sk = {
    top:       createSkin(CX,       CY-BRY),
    stemTip:   createSkin(CX-8,     CY-BRY-46),
    lf1Base:   createSkin(CX-4,     CY-BRY-8),
    lf1Tip:    createSkin(CX-36,    CY-BRY-58),
    lf2Base:   createSkin(CX+4,     CY-BRY-4),
    lf2Tip:    createSkin(CX+40,    CY-BRY-44),
    eyeL:      createSkin(CX-33,    CY-30),
    eyeR:      createSkin(CX+33,    CY-30),
    cheekL:    createSkin(CX-58,    CY+4),
    cheekR:    createSkin(CX+58,    CY+4),
    mouthL:    createSkin(CX-30,    CY+20),
    mouthR:    createSkin(CX+30,    CY+20),
    mouthBot:  createSkin(CX,       CY+44),
    hl1:       createSkin(CX-32,    CY-54),
    hl2:       createSkin(CX-48,    CY-32),
    // Speckles (just for visual texture, no physics needed — sampled from pts)
    sp: [
      createSkin(CX+28, CY+14,  4),
      createSkin(CX-42, CY+32,  4),
      createSkin(CX+52, CY-8,   4),
      createSkin(CX-18, CY-48,  4),
      createSkin(CX+28, CY+52,  4),
      createSkin(CX-52, CY+12,  4),
      createSkin(CX+10, CY-66,  4),
      createSkin(CX+60, CY+30,  4),
      createSkin(CX-30, CY+62,  4),
    ]
  };

  /* ── Physics ─────────────────────────────────────────── */
  const DAMP     = 0.90;   // Verlet velocity damping (per substep)
  const REST_K   = 0.006;  // Weak global attraction to original shape
  const SUBSTEPS = 12;     // Sub-steps per frame (stability)

  let grabbed  = null;  // index of grabbed point
  let mouseX   = CX, mouseY = CY;
  let isDown   = false;
  let idleT    = 0;
  let hintHidden = false;

  // Measure deformation intensity (for expressions)
  let stretchMag = 0;

  function physicsStep(){
    for(let step=0; step<SUBSTEPS; step++){

      // ─ Spring constraint solve ─
      for(const sp of springs){
        const a=pts[sp.a], b=pts[sp.b];
        const dx=b.x-a.x, dy=b.y-a.y;
        const len=Math.sqrt(dx*dx+dy*dy)||0.001;
        const mag=(len-sp.rest)*sp.k*0.5;
        const nx=dx/len*mag, ny=dy/len*mag;
        if(grabbed!==sp.a){ a.x+=nx; a.y+=ny; }
        if(grabbed!==sp.b){ b.x-=nx; b.y-=ny; }
      }

      // ─ Verlet integrate ─
      for(let i=0;i<TOTAL;i++){
        if(i===grabbed) continue;
        const p=pts[i];
        const vx=(p.x-p.ox)*DAMP;
        const vy=(p.y-p.oy)*DAMP;
        p.ox=p.x; p.oy=p.y;
        p.x+=vx;
        p.y+=vy;
      }

      // ─ Weak rest-shape attraction ─
      for(let i=0;i<TOTAL;i++){
        if(i===grabbed) continue;
        pts[i].x += (pts[i].rx-pts[i].x)*REST_K;
        pts[i].y += (pts[i].ry-pts[i].y)*REST_K;
      }

      // ─ Move grabbed point to mouse ─
      if(grabbed!==null){
        const p=pts[grabbed];
        const tx=mouseX, ty=mouseY;
        p.ox=p.x; p.oy=p.y;
        // Lag: 80% lerp to mouse per substep
        p.x+=(tx-p.x)*0.8;
        p.y+=(ty-p.y)*0.8;
      }
    }

    // Measure stretch: max distance of any perimeter pt from rest
    let maxD=0;
    for(let i=0;i<N;i++){
      const d=Math.hypot(pts[i].x-pts[i].rx, pts[i].y-pts[i].ry);
      if(d>maxD) maxD=d;
    }
    stretchMag += (maxD/60 - stretchMag)*0.12;
    stretchMag = Math.min(stretchMag, 4);
  }

  /* ── Idle breathing ─────────────────────────────────── */
  function applyIdle(){
    if(grabbed!==null) return;
    idleT+=0.018;
    const breath = Math.sin(idleT*0.75)*0.4;
    const sway   = Math.sin(idleT*0.45)*0.25;
    // Gentle vertical breathe
    pts[0].y      -= breath*0.5;   // top
    pts[N>>1].y   += breath*0.3;   // bottom
    // Subtle horizontal sway on sides
    pts[Math.round(N*0.25)].x += sway*0.4; // right
    pts[Math.round(N*0.75)].x -= sway*0.4; // left
  }

  /* ── Drawing ─────────────────────────────────────────── */
  function catmullPath(points){
    const n=points.length;
    ctx.beginPath();
    for(let i=0;i<n;i++){
      const p0=points[(i-1+n)%n];
      const p1=points[i];
      const p2=points[(i+1)%n];
      const p3=points[(i+2)%n];
      if(i===0) ctx.moveTo(p1.x, p1.y);
      const cp1x=p1.x+(p2.x-p0.x)/6;
      const cp1y=p1.y+(p2.y-p0.y)/6;
      const cp2x=p2.x-(p3.x-p1.x)/6;
      const cp2y=p2.y-(p3.y-p1.y)/6;
      ctx.bezierCurveTo(cp1x,cp1y, cp2x,cp2y, p2.x,p2.y);
    }
    ctx.closePath();
  }

  function draw(){
    ctx.clearRect(0,0,W,H);
    const peri = pts.slice(0,N);

    // ── Drop shadow ─────────────────────────────────────
    const ctrX = pts[C_IDX].x, ctrY = pts[C_IDX].y;
    const shY  = CY + BRY + 16;
    ctx.save();
    const sh = ctx.createRadialGradient(ctrX, shY, 4, ctrX, shY, 90);
    sh.addColorStop(0,'rgba(0,0,0,0.40)');
    sh.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=sh;
    ctx.beginPath();
    ctx.ellipse(ctrX, shY, 88, 18, 0, 0, Math.PI*2);
    ctx.fill();
    ctx.restore();

    // ── Lemon body ───────────────────────────────────────
    catmullPath(peri);
    const grad = ctx.createRadialGradient(ctrX-24, ctrY-34, 8, ctrX, ctrY, BRX*1.4);
    grad.addColorStop(0,   '#FEFB8A');
    grad.addColorStop(0.38,'#F5E132');
    grad.addColorStop(0.80,'#E8C800');
    grad.addColorStop(1,   '#C8A000');
    ctx.fillStyle=grad;
    ctx.fill();

    // Thick pixel-art outline
    catmullPath(peri);
    ctx.strokeStyle='#1A1200';
    ctx.lineWidth=4.5;
    ctx.stroke();

    // Rim highlight
    catmullPath(peri);
    ctx.strokeStyle='rgba(255,255,180,0.12)';
    ctx.lineWidth=10;
    ctx.stroke();

    // ── Surface speckles ────────────────────────────────
    ctx.fillStyle='rgba(180,130,0,0.20)';
    for(const sp of sk.sp){
      ctx.beginPath();
      ctx.arc(sp.x, sp.y, 2.8, 0, Math.PI*2);
      ctx.fill();
    }

    // ── Highlight gloss ─────────────────────────────────
    ctx.save();
    const hl1 = ctx.createRadialGradient(sk.hl1.x,sk.hl1.y,2, sk.hl1.x,sk.hl1.y,34);
    hl1.addColorStop(0,'rgba(255,255,255,0.60)');
    hl1.addColorStop(1,'rgba(255,255,255,0)');
    ctx.fillStyle=hl1;
    ctx.beginPath();
    ctx.ellipse(sk.hl1.x,sk.hl1.y, 22, 30, -0.45, 0, Math.PI*2);
    ctx.fill();
    const hl2 = ctx.createRadialGradient(sk.hl2.x,sk.hl2.y,1, sk.hl2.x,sk.hl2.y,15);
    hl2.addColorStop(0,'rgba(255,255,255,0.32)');
    hl2.addColorStop(1,'rgba(255,255,255,0)');
    ctx.fillStyle=hl2;
    ctx.beginPath();
    ctx.arc(sk.hl2.x,sk.hl2.y, 12, 0, Math.PI*2);
    ctx.fill();
    ctx.restore();

    // ── Stem ────────────────────────────────────────────
    ctx.save();
    ctx.strokeStyle='#3A2000';
    ctx.lineWidth=6; ctx.lineCap='round';
    ctx.beginPath();
    ctx.moveTo(sk.top.x, sk.top.y);
    ctx.lineTo(sk.stemTip.x, sk.stemTip.y);
    ctx.stroke();
    // Lighter top edge
    ctx.strokeStyle='#7A5020';
    ctx.lineWidth=2;
    ctx.beginPath();
    ctx.moveTo(sk.top.x-1, sk.top.y);
    ctx.lineTo(sk.stemTip.x-1, sk.stemTip.y);
    ctx.stroke();
    ctx.restore();

    // ── Leaves ──────────────────────────────────────────
    function drawLeaf(base, tip, halfW, col1, col2){
      const ang  = Math.atan2(tip.y-base.y, tip.x-base.x);
      const perp = ang + Math.PI/2;
      const cos1 = Math.cos(perp)*halfW;
      const sin1 = Math.sin(perp)*halfW;
      ctx.beginPath();
      ctx.moveTo(base.x, base.y);
      ctx.bezierCurveTo(
        base.x+cos1*0.9, base.y+sin1*0.9,
        tip.x+cos1*0.25, tip.y+sin1*0.25,
        tip.x, tip.y);
      ctx.bezierCurveTo(
        tip.x-cos1*0.25, tip.y-sin1*0.25,
        base.x-cos1*0.9, base.y-sin1*0.9,
        base.x, base.y);
      ctx.closePath();
      const lg = ctx.createLinearGradient(base.x,base.y, tip.x,tip.y);
      lg.addColorStop(0, col1); lg.addColorStop(1, col2);
      ctx.fillStyle=lg; ctx.fill();
      ctx.strokeStyle='#1A5020'; ctx.lineWidth=1.8; ctx.stroke();
      // Vein
      ctx.beginPath();
      ctx.moveTo(base.x,base.y); ctx.lineTo(tip.x,tip.y);
      ctx.strokeStyle='rgba(255,255,255,0.18)'; ctx.lineWidth=1; ctx.stroke();
    }
    ctx.save();
    drawLeaf(sk.lf1Base, sk.lf1Tip, 20, '#2D8C40','#55C060');
    drawLeaf(sk.lf2Base, sk.lf2Tip, 15, '#2D8C40','#48B055');
    ctx.restore();

    // ── Cheeks ──────────────────────────────────────────
    ctx.save();
    for(const cp of [sk.cheekL, sk.cheekR]){
      const cg = ctx.createRadialGradient(cp.x,cp.y,0, cp.x,cp.y,24);
      cg.addColorStop(0,'rgba(255,140,175,0.62)');
      cg.addColorStop(1,'rgba(255,140,175,0)');
      ctx.fillStyle=cg;
      ctx.beginPath();
      ctx.ellipse(cp.x,cp.y, 24,17, 0, 0, Math.PI*2);
      ctx.fill();
    }
    ctx.restore();

    // ── Eyes ─────────────────────────────────────────────
    // Widen/grow when stretched (like Mario 64 panic face)
    const eyeW = 9  + Math.min(stretchMag*5,  12);
    const eyeH = 13 + Math.min(stretchMag*6,  14);
    ctx.save();
    for(const ep of [sk.eyeL, sk.eyeR]){
      // White sclera
      ctx.fillStyle='rgba(255,255,255,0.12)';
      ctx.beginPath();
      ctx.ellipse(ep.x, ep.y, eyeW+3, eyeH+3, 0, 0, Math.PI*2);
      ctx.fill();
      // Dark pupil
      ctx.fillStyle='#1A0D00';
      ctx.beginPath();
      ctx.ellipse(ep.x, ep.y, eyeW, eyeH, 0, 0, Math.PI*2);
      ctx.fill();
      // Shine dot
      ctx.fillStyle='rgba(255,255,255,0.85)';
      ctx.beginPath();
      ctx.ellipse(ep.x-eyeW*0.28, ep.y-eyeH*0.28, eyeW*0.32, eyeH*0.28, 0, 0, Math.PI*2);
      ctx.fill();
    }
    ctx.restore();

    // ── Mouth / expression ───────────────────────────────
    const mL  = sk.mouthL, mR  = sk.mouthR, mBot = sk.mouthBot;
    ctx.save();

    if(stretchMag > 1.8){
      // PANIC — big O mouth (SM64 face-stretch surprise)
      const mc = { x:(mL.x+mR.x)/2, y:(mL.y+mBot.y*1.2)/2.2 };
      const ow = 14 + stretchMag*4;
      const oh = 18 + stretchMag*5;
      ctx.fillStyle='#2A1000';
      ctx.beginPath();
      ctx.ellipse(mc.x, mc.y+4, ow, oh, 0, 0, Math.PI*2);
      ctx.fill();
      ctx.strokeStyle='#1A0800';
      ctx.lineWidth=3;
      ctx.stroke();
    } else if(stretchMag > 0.6){
      // MILD SURPRISE — wider smile
      ctx.beginPath();
      ctx.moveTo(mL.x, mL.y);
      ctx.quadraticCurveTo(mBot.x, mBot.y+10+stretchMag*5, mR.x, mR.y);
      ctx.strokeStyle='#1A0D00'; ctx.lineWidth=4.5; ctx.lineCap='round'; ctx.stroke();
      // Fill inner mouth
      ctx.beginPath();
      ctx.moveTo(mL.x, mL.y);
      ctx.quadraticCurveTo(mBot.x, mBot.y+12+stretchMag*5, mR.x, mR.y);
      ctx.lineTo(mR.x, mR.y-3);
      ctx.quadraticCurveTo(mBot.x, mBot.y+4, mL.x, mL.y-3);
      ctx.fillStyle='#2A1000'; ctx.fill();
    } else {
      // HAPPY — normal cheerful smile
      ctx.beginPath();
      ctx.moveTo(mL.x, mL.y);
      ctx.quadraticCurveTo(mBot.x, mBot.y+6, mR.x, mR.y);
      ctx.strokeStyle='#1A0D00'; ctx.lineWidth=4.5; ctx.lineCap='round'; ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(mL.x, mL.y);
      ctx.quadraticCurveTo(mBot.x, mBot.y+8, mR.x, mR.y);
      ctx.lineTo(mR.x, mR.y-2);
      ctx.quadraticCurveTo(mBot.x, mBot.y+2, mL.x, mL.y-2);
      ctx.fillStyle='#2A1000'; ctx.fill();
    }
    ctx.restore();

    // ── Grab indicator: dashed ring at grabbed point ─────
    if(grabbed!==null){
      const gp = pts[grabbed];
      ctx.save();
      ctx.beginPath();
      ctx.arc(gp.x, gp.y, 18, 0, Math.PI*2);
      ctx.setLineDash([5,5]);
      ctx.strokeStyle='rgba(245,225,50,0.55)';
      ctx.lineWidth=2;
      ctx.stroke();
      ctx.setLineDash([]);
      // small center dot
      ctx.beginPath();
      ctx.arc(gp.x, gp.y, 3, 0, Math.PI*2);
      ctx.fillStyle='rgba(245,225,50,0.6)';
      ctx.fill();
      ctx.restore();
    }

    // ── Debug: draw spring skeleton (toggle with 'D') ────
    if(debugMode){
      ctx.save();
      ctx.strokeStyle='rgba(245,225,50,0.06)';
      ctx.lineWidth=0.8;
      for(const sp of springs){
        ctx.beginPath();
        ctx.moveTo(pts[sp.a].x, pts[sp.a].y);
        ctx.lineTo(pts[sp.b].x, pts[sp.b].y);
        ctx.stroke();
      }
      ctx.fillStyle='rgba(245,225,50,0.3)';
      for(const p of pts){
        ctx.beginPath();
        ctx.arc(p.x,p.y,2.5,0,Math.PI*2);
        ctx.fill();
      }
      ctx.restore();
    }
  }

  /* ── Input handling ──────────────────────────────────── */
  let debugMode = false;
  document.addEventListener('keydown', e=>{
    if(e.key==='d'||e.key==='D') debugMode=!debugMode;
  });

  function getCP(e){
    const r   = canvas.getBoundingClientRect();
    const scX = W/r.width, scY = H/r.height;
    const cx  = e.touches ? e.touches[0].clientX : e.clientX;
    const cy  = e.touches ? e.touches[0].clientY : e.clientY;
    return { x:(cx-r.left)*scX, y:(cy-r.top)*scY };
  }

  function inLemon(x,y){
    return Math.pow((x-CX)/BRX,2) + Math.pow((y-CY)/BRY,2) < 1.2;
  }

  function findGrab(x,y){
    // Find the nearest perimeter or inner point to cursor
    let best=null, bestD=Infinity;
    for(let i=0;i<N;i++){    // perimeter only — feels like grabbing the surface
      const d=Math.hypot(pts[i].x-x, pts[i].y-y);
      if(d<bestD){ bestD=d; best=i; }
    }
    // Accept grab if: inside lemon (any range), or outside but within 50px of surface
    if(inLemon(x,y) && bestD < 160) return best;
    if(!inLemon(x,y) && bestD < 50) return best;
    return null;
  }

  function onDown(e){
    const pos = getCP(e);
    mouseX=pos.x; mouseY=pos.y;
    const g = findGrab(pos.x, pos.y);
    if(g===null) return;
    grabbed=g; isDown=true;
    canvas.classList.add('grabbed');
    // Cancel momentum of grabbed point so it snaps cleanly
    pts[g].ox=pts[g].x; pts[g].oy=pts[g].y;
    // Hide hint after first interaction
    if(!hintHidden){
      const sh=document.getElementById('squeezeHint'); if(sh) sh.style.opacity='0';
      hintHidden=true;
    }
  }
  function onMove(e){
    if(!isDown||grabbed===null) return;
    const pos=getCP(e);
    mouseX=pos.x; mouseY=pos.y;
  }
  function onUp(){
    if(grabbed!==null){
      // Give a tiny release impulse so it bounces nicely
      const p=pts[grabbed];
      const vx=(p.x-p.ox)*0.25;
      const vy=(p.y-p.oy)*0.25;
      p.ox=p.x-vx; p.oy=p.y-vy;
    }
    grabbed=null; isDown=false;
    canvas.classList.remove('grabbed');
  }

  canvas.addEventListener('mousedown',  onDown);
  window.addEventListener('mousemove',  onMove);
  window.addEventListener('mouseup',    onUp);
  canvas.addEventListener('touchstart', e=>{ e.preventDefault(); onDown(e); }, {passive:false});
  canvas.addEventListener('touchmove',  e=>{ e.preventDefault(); onMove(e); }, {passive:false});
  canvas.addEventListener('touchend',   e=>{ e.preventDefault(); onUp();   }, {passive:false});

  // Cursor hint: show grab icon when hovering lemon
  canvas.addEventListener('mousemove', e=>{
    const pos=getCP(e);
    canvas.style.cursor = inLemon(pos.x,pos.y) ? 'grab' : 'default';
  });

  /* ── Main loop ───────────────────────────────────────── */
  function loop(){
    requestAnimationFrame(loop);
    applyIdle();
    physicsStep();
    draw();
  }
  loop();

})(); // end initSqueeze

/* ════════════════════════════════════════════════════════
   7. SCROLL REVEAL (simple IntersectionObserver)
════════════════════════════════════════════════════════ */
const revealEls = document.querySelectorAll('.pc, .perk, .about-cell');
revealEls.forEach(el=>{
  el.style.opacity='0';
  el.style.transform='translateY(28px)';
  el.style.transition='opacity 0.7s var(--ease), transform 0.7s var(--ease)';
});
const revealObs = new IntersectionObserver(entries=>{
  entries.forEach((e,i)=>{
    if(e.isIntersecting){
      setTimeout(()=>{
        e.target.style.opacity='1';
        e.target.style.transform='translateY(0)';
      }, i*60);
      revealObs.unobserve(e.target);
    }
  });
},{threshold:0.12});
revealEls.forEach(el=>revealObs.observe(el));